import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "image" };
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "game" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "GAMES"),
    /*#__PURE__*/ _createElementVNode("div", { class: "game-day" }, "TBA"),
    /*#__PURE__*/ _createCommentVNode(" <div class=\"game-hours\">17:00 hrs. @ GYM #3</div> "),
    /*#__PURE__*/ _createElementVNode("div", { class: "coaches" }, [
        /*#__PURE__*/ _createElementVNode("h4", null, "COACHES:"),
        /*#__PURE__*/ _createElementVNode("p", null, "TBA")
    ]),
    /*#__PURE__*/ _createCommentVNode(" <div class=\"gallery\">\n\t\t\t\t\t\t<h4>GALLERY</h4>\n\t\t\t\t\t</div> ")
], -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
        return (_openBlock(), _createElementBlock("article", {
            key: item.id
        }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("figure", null, [
                    _createElementVNode("img", {
                        src: item.image,
                        alt: item.image_credit
                    }, null, 8 /* PROPS */, _hoisted_2),
                    _createElementVNode("figcaption", null, _toDisplayString(item.name.toUpperCase()), 1 /* TEXT */)
                ]),
                _createCommentVNode(" <div>\n\t\t\t\t{{ item.description }}\n\t\t\t</div> ")
            ]),
            _hoisted_3
        ]));
    }), 128 /* KEYED_FRAGMENT */));
}
